import ScreenContainer from '@/components/ScreenContainer';
import useThemeProvider from '@/hooks/useThemeProvider';
import React, { useEffect, useState } from 'react';

function Loading() {
  const { ThemeProviderPro } = useThemeProvider();
  const [error, setError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setError(true);
    }, 6000);
  }, []);

  if (BRAND === 'sensforge') {
    return (
      <ThemeProviderPro>
        <ScreenContainer doing={false} loading={true} error={error}></ScreenContainer>
      </ThemeProviderPro>
    );
  }

  return (
    <ThemeProviderPro>
      <ScreenContainer doing={false} loading={true} error={error}></ScreenContainer>
    </ThemeProviderPro>
  );
}

export default Loading;
